module.exports = __webpack_public_path__ + "img/4.9d312c9c.png";